module.exports = __webpack_public_path__ + "img/handraw_localisation blanc.2983752e.svg";